/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconArena: {
  name: 'arena';
  data: string;
} = {
  name: 'arena',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M292.99 4.208c-3.188 1.594-3.586 2.391-3.586 2.391 3.188 12.75.398 21.914-1.195 29.883 0 0 .797 1.992 7.172 3.586V23.333c-.001-6.375-2.391-19.125-2.391-19.125zm28.687 0s-2.391 12.75-2.391 19.125v16.734c6.375-1.594 7.172-3.586 7.172-3.586-1.594-7.969-4.383-17.133-1.195-29.883 0 .001-.398-.796-3.586-2.39zm-16.734 14.344c-3.188 0-7.172 1.195-7.172 1.195v21.516s3.984 1.195 7.172 1.195h4.781c3.188 0 7.172-1.195 7.172-1.195V19.747s-3.984-1.195-7.172-1.195h-4.781z" transform="matrix(15 0 0 15 -4304 -44)"/></svg>`,
};
